import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-button-sm',
  templateUrl: './edit-button-sm.component.html',
  styleUrls: ['./edit-button-sm.component.scss']
})
export class EditButtonSmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
